// extracted by mini-css-extract-plugin
module.exports = {"ArticlesList__item":"ArticlesList_ArticlesList__item__3yIni"};